module.exports = __webpack_public_path__ + "static/condo_screen-google-4d21e657a6111c0ecd111df218dae058.jpg";